module.exports = __webpack_public_path__ + "img/list_icon3.ae0aaa82.png";